import { Collection } from 'modules/core/lib/mobx-rest'

import Office from 'modules/company_page/store/models/Office'

class Offices extends Collection<Office> {
  get cacheKey(): string {
    return 'offices'
  }

  model() {
    return Office
  }
}

export { Offices }
